"use client";

import { useSearchParams } from "next/navigation";
import PageContent from "./pageContent";

type Props = {
  brand?: string;
  vendor?: string;
  style?: string;
  type?: string;
  searchText?: string;
};

const SearchContent = ({ brand, vendor, style, type, searchText }: Props) => {
  const searchParams = useSearchParams();
  const regionFilters = searchParams.getAll("regions");
  const brandFilters = searchParams.getAll("brands");
  const vendorFilters = searchParams.getAll("vendors");
  const filterId = searchParams.get("filterid");
  const clearFilters = searchParams.get("clearFilters") === "1";
  const fromNotification = searchParams.get("kurbo") === "1";
  // Deep-link entry point for "find similar by this image" from outside the
  // app (e.g. a Discord post's "Find Similar" button) — same flow the
  // in-app FIND MORE button triggers, just sourced from a URL instead of a
  // click on an item already in memory.
  const imageSearchUrl = searchParams.get("imageSearchUrl") || undefined;
  // Deep-link entry point for a filter someone else shared (SaveInput's
  // share icon copies /search?share=<token>) — public, unauthenticated, and
  // unrelated to filterid above (which only resolves the viewer's own saved
  // filters by id).
  const sharedFilterToken = searchParams.get("share") || undefined;

  return (
    <PageContent
      brand={brand}
      vendor={vendor}
      style={style}
      type={type}
      searchText={searchText}
      regions={regionFilters}
      brands={brandFilters}
      vendors={vendorFilters}
      filterId={filterId ? parseInt(filterId) : undefined}
      clearFilters={clearFilters}
      fromNotification={fromNotification}
      imageSearchUrl={imageSearchUrl}
      sharedFilterToken={sharedFilterToken}
    />
  );
};

export default SearchContent;
